import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />

      <section className="hero" style={{ minHeight: '30vh', paddingTop: '120px', paddingBottom: '40px' }}>
        <div className="container text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <span className="badge">📜 Legal Agreement</span>
            <h1 className="hero-title" style={{ fontSize: '3rem', marginTop: 16 }}>
              Terms of <span className="text-gradient">Service</span>
            </h1>
            <p className="hero-subtitle" style={{ margin: '0 auto', maxWidth: 600 }}>
              Last updated: March 2026. Please read these terms carefully before using our platform.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="container">
          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.6, delay: 0.2 }}
            className="glass-card" 
            style={{ padding: '60px', maxWidth: 900, margin: '0 auto', textAlign: 'left', lineHeight: 1.8 }}
          >
            <h2 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: 16, color: 'var(--text-primary)' }}>1. Acceptance of Terms</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 32 }}>
              By accessing and using the InfraVelox (the "Service"), you accept and agree to be bound by the terms and provision of this agreement. In addition, when using these particular services, you shall be subject to any posted guidelines or rules applicable to such services.
            </p>

            <h2 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: 16, color: 'var(--text-primary)' }}>2. Description of Service</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 32 }}>
              We provide an online platform connecting users with DevOps engineering experts for mentorship, technical support, code review, and related educational services. The service is provided "AS IS". We reserve the right to modify, suspend, or discontinue the service with or without notice at any time and without any liability to you.
            </p>

            <h2 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: 16, color: 'var(--text-primary)' }}>3. User Conduct</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 16 }}>
              You agree to use the Service only for lawful purposes. You agree not to take any action that might compromise the security of the site, render the site inaccessible to others or otherwise cause damage to the site or the Content. You agree not to add to, subtract from, or otherwise modify the Content, or to attempt to access any Content that is not intended for you.
            </p>

            <h2 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: 16, color: 'var(--text-primary)' }}>4. Payment and Subscriptions</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 32 }}>
              Service access requires a valid subscription plan. Subscription fees are billed in advance and are non-refundable unless explicitly stated under our Refund Policy. It is your responsibility to cancel your plan if you no longer wish to use the Service. We reserve the right to change our pricing upon reasonable notice.
            </p>

            <h2 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: 16, color: 'var(--text-primary)' }}>5. Mentorship and SLAs</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 32 }}>
              Our expert support guarantees response times according to the Service Level Agreement (SLA) outlined in your specific payment plan. While our experts aim to provide 100% accurate and immediate resolutions, you acknowledge that infrastructure challenges vary in complexity, and some solutions may require extended investigation. By adopting any guidance, code snippets, or architectural suggestions provided, you assume full responsibility for thoroughly testing them in non-production environments first.
            </p>

            <h2 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: 16, color: 'var(--text-primary)' }}>6. Limitation of Liability</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 32 }}>
              In no event shall InfraVelox or our suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our website, even if we have been notified orally or in writing of the possibility of such damage.
            </p>

            <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: 32, marginTop: 40, color: 'var(--text-muted)' }}>
              If you have any questions about these Terms, please contact us at <a href="mailto:legal@infravelox.com" style={{ color: 'var(--brand-primary)', textDecoration: 'none' }}>legal@infravelox.com</a>.
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </>
  );
}
